// @ts-nocheck
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
    OrderActionSetPresentationProps,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import ShareEntityButton, { ShareEntityButtonStyles } from "@store/Overrides/Components/ShareEntityButton";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { useContext } from "react";

const enum fields {
    showPrint = "showPrint",
    showShareViaEmail = "showShareViaEmail",
}

export interface InvoiceDetailsActionsPresentationProps extends ExpandStyles<InvoiceDetailsActionsStyles> {}

export interface InvoiceDetailsActionsProps extends InvoiceDetailsActionsPresentationProps, WidgetProps {
    fields: {
        [fields.showPrint]?: boolean;
        [fields.showShareViaEmail]?: boolean;
    };
}

export interface InvoiceDetailsActionsStyles {
    actionSet?: OrderActionSetPresentationProps;
    shareEntityStyles?: ShareEntityButtonStyles;
    printButton?: ButtonPresentationProps;
    printLink?: LinkPresentationProps;
}

export const invoiceDetailsActionsStyles: InvoiceDetailsActionsStyles = {};

const InvoiceDetailsActions = ({
    fields: widgetFields,
    extendedStyles,
    overridedStyles,
}: InvoiceDetailsActionsProps) => {
    const styles = useExpandProps(invoiceDetailsActionsStyles, extendedStyles, overridedStyles);
    const { value: invoice } = useContext(InvoiceStateContext);

    if (!invoice) {
        return null;
    }

    return (
        <OrderActionSet
            {...styles.actionSet}
            fields={widgetFields}
            actions={[
                {
                    preset: "print",
                    buttonStyles: styles.printButton,
                    linkStyles: styles.printLink,
                    field: fields.showPrint,
                },
                {
                    button: (
                        <ShareEntityButton
                            key="share"
                            entityId={invoice.invoiceNumber}
                            entityName="Invoice"
                            extendedStyles={styles.shareEntityStyles}
                        />
                    ),
                    link: (
                        <ShareEntityButton
                            key="share"
                            entityId={invoice.invoiceNumber}
                            entityName="Invoice"
                            extendedStyles={styles.shareEntityStyles}
                            variant="clickable"
                        />
                    ),
                    field: fields.showShareViaEmail,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsActions,
    definition: {
        group: "Invoice History",
        allowedContexts: ["InvoiceDetailsPage"],
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([
            { name: fields.showShareViaEmail },
            { name: fields.showPrint },
        ]),
    },
};

export default widgetModule;
